import { render, staticRenderFns } from "./classCourse.vue?vue&type=template&id=52b4131e&scoped=true"
import script from "./classCourse.vue?vue&type=script&lang=js"
export * from "./classCourse.vue?vue&type=script&lang=js"
import style0 from "./classCourse.vue?vue&type=style&index=0&id=52b4131e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b4131e",
  null
  
)

export default component.exports